<template>
    <div>
        <v-chart-stock-mini-trend :key="symbol_code+'_'+(selected_date||'real')" :style="chart_style()" :options="line" :autoresize="true" />
    </div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import { request_zzquant } from "network/request.js"


		export default {
			props: {
				symbol_code: String,
				chart_heigh:{type:String,default:'50px'},
				chart_width:{type:String,default:'100%'},
				selected_date: String,
				refresh_seq: {type: Number, default: 0},
			},
			watch: {
				symbol_code: 'refresh',
				selected_date: 'refresh',
				refresh_seq: 'refresh'
			},
		components: {
			'v-chart-stock-mini-trend': ECharts
		},
		data() {
			return {
				line: {
					grid: {
						left: 0,
						right: 0,
						top: 0,
						bottom: 0,
                        containLabel: false
					},
					xAxis: {
						type: 'category',
						show: false,
						boundaryGap: false,
                        min: 'dataMin',
                        max: '15:00',
                        data: []
					},
					yAxis: {
						type: 'value',
						show: false,
						min: function(value) {
                            return value.min > -10 ? -10 : value.min
                        },
                        max: function(value) {
                            return value.max < 10 ? 10 : value.max
                        },
					},
					series: [
                        {
							name: '涨幅',
							type: 'line',
							showSymbol: false,
							symbol: 'none',
						lineStyle: {
								normal: {
									width: 1,
                                    color: '#999999'
								}
							},
                            data: []
						},
                        {
                            name: '均线',
                            type: 'line',
                            showSymbol: false,
                            symbol: 'none',
                            smooth: true,
                            lineStyle: {
                                normal: {
                                    width: 1,
                                    color: '#FFC04C',
                                    opacity: 0.5
                                }
                            },
                            data: []
                        },
                        // 中轴线
                        {
                            type: 'line',
                            markLine: {
                                symbol: 'none',
                                label: { show: false },
                                lineStyle: {
                                    type: 'dashed',
                                    color: '#999',
                                    width: 0.5
                                },
                                data: [
                                    { yAxis: 0 }
                                ]
                            }
                        }
					],
                    visualMap: {
                        show: false,
                        seriesIndex: 0,
                        dimension: 1,
                        pieces: [{
                            gt: 0,
                            color: '#ec0000'
                        }, {
                            lte: 0,
                            color: '#00da3c'
                        }]
                    }
				}
			}
		},
		mounted() {
			this.refresh();
		},
		methods: {
			chart_style() {
				return {
					width: this.chart_width,
					height: this.chart_heigh,
				}
			},
			refresh() {
				if (!this.symbol_code) return;
				if (this.symbol_code.length != 6) return;

				const key = this.symbol_code + '_' + (this.selected_date || 'real') + '_' + (this.refresh_seq || 0);
				const w = window;
				w.__miniTrendCache = w.__miniTrendCache || {};
				w.__miniTrendPending = w.__miniTrendPending || {};

				const cached = w.__miniTrendCache[key];
				if (cached) {
					this.applyTrend(cached);
					return;
				}

				if (w.__miniTrendPending[key]) {
					w.__miniTrendPending[key].then(data => {
						this.applyTrend(data);
					});
					return;
				}

				let url1 = '/v3/market/trend/' + this.symbol_code;
				if (this.selected_date) {
					url1 = url1 + '/date/' + this.selected_date;
				}

				const promise = request_zzquant({'url': url1}).then(resp1 => {
					const raw = resp1['data']['data'];
					w.__miniTrendCache[key] = raw;
					delete w.__miniTrendPending[key];
					return raw;
				}).catch(err => { 
					console.log(err); 
					delete w.__miniTrendPending[key];
				});

				w.__miniTrendPending[key] = promise;
				promise.then(data => {
					if(data) this.applyTrend(data);
				});
			},
			applyTrend(raw){
				let splitDataItem = this.splitData(raw);
				this.line.xAxis.data = splitDataItem.categoryData;
				this.line.series[0].data = splitDataItem.values_price_pct;
				this.line.series[1].data = splitDataItem.values_price_avg_pct;
				const arr = splitDataItem.values_price_pct || [];
				const last = arr.length ? parseFloat(arr[arr.length-1]) : 0;
				const color = last>0 ? '#ec0000' : (last<0 ? '#00da3c' : '#999999');
				const s0 = this.line.series[0] || {};
				const ls = s0.lineStyle || {};
				const ln = ls.normal || {};
				const s0_new = Object.assign({}, s0, { lineStyle: Object.assign({}, ls, { normal: Object.assign({}, ln, { color }) }) });
				this.line.series = [s0_new, this.line.series[1], this.line.series[2]];
				this.line.visualMap = undefined;
				if(!this.line.xAxis.data || this.line.xAxis.data.length===0){
					this.line.xAxis.data = ['09:30','15:00'];
					this.line.series[0].data = [0,0];
					this.line.series[1].data = [0,0];
				}
				this.$nextTick(()=>{ this.line = Object.assign({}, this.line); });
			},
			pct_pcire(pre_close, price) {
				if (price == 0) {
					return 0;
				}
				return ((price - pre_close) / pre_close * 100).toFixed(2);
			},
			splitData(rawData) {
				let [categoryData, values_price_pct, values_price_avg_pct] = [[], [], []];
				var pre_close = rawData['preclose_px'];
				
				if (rawData['trend']) {
					rawData['trend'].forEach(trend => {
						categoryData.push(trend[0]);
						values_price_pct.push(this.pct_pcire(pre_close, trend[1]));
						values_price_avg_pct.push(this.pct_pcire(pre_close, trend[2]));
					})
				}

				return {
					categoryData: categoryData,
					values_price_pct: values_price_pct,
					values_price_avg_pct: values_price_avg_pct,
				};
			}
		}
	}
</script>

<style scoped>
</style>
